<template>
    <div class="task_box">
        <div class="header_box">
            <div class="condition_box">
                <div class="label_box">训练分类：</div>
                <div class="value_box">
                    <div :class="[{ select: filter.type == -1 }]" @click="chooseFilter('type', -1)">全部</div>
                    <div
                        v-for="item in sortList"
                        :class="[{ select: filter.type == item.id }]"
                        :key="item.id"
                        @click="chooseFilter('type', item.id)"
                    >
                        {{ item.title }}
                    </div>
                </div>
            </div>
            <div class="condition_box">
                <div class="label_box">训练筛选：</div>
                <div class="value_box">
                    <div :class="[{ select: filter.status == -1 }]" @click="chooseFilter('status', -1)">全部</div>
                    <div
                        v-for="item in selectTask"
                        :class="[{ select: filter.status == item.id }]"
                        :key="item.id"
                        @click="chooseFilter('status', item.id)"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <div class="condition_box">
                <div class="label_box">条件筛选：</div>
                <div class="value_box">
                    <div :class="[{ select: filter.condition == -1 }]" @click="chooseFilter('condition', -1)">全部</div>
                    <div
                        v-for="item in selectCondition"
                        :class="[{ select: filter.condition == item.id }]"
                        :key="item.id"
                        @click="chooseFilter('condition', item.id)"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>
        <div class="detial_box">
            <div class="all_task_show" v-if="taskList.length > 0">
                <div class="task_detial" v-for="item in taskList" :key="item.task_id">
                    <div class="image">
                        <img :src="item.task_cover" alt="" />
                        <span class="tip" v-if="item.enroll"> {{ enrollLabel[item.enroll] }} </span>
                    </div>
                    <div class="traing_detial">
                        <div class="title">{{ item.task_title }}</div>
                        <div class="images">
                            <img :src="item.head_portrait ? item.head_portrait : require('../../assets/img/image/user_img.png')" alt="" />
                            <span class="ellipsis-single">{{ item.name }}</span>
                        </div>
                        <!-- <div class="tip">参与班级：产品测试班级</div> -->
                        <div class="footer_box">
                            <span>发布时间：2分钟前</span>
                            <el-button @click="goDetial(item)">查看任务</el-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="detail-empty flex-center" v-else>暂无数据</div>
        </div>

        <div class="pagination">
            <el-pagination
                v-if="taskList.length > 0"
                class="pages-center"
                :current-page="pageParams.page"
                :page-size="pageParams.page_size"
                layout="prev, pager, next, jumper"
                :total="pageParams.total"
                @current-change="handlePageChange"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: "",
    data() {
        return {
            taskList: [], // 训练列表
            filter: {
                type: -1, // 训练分类
                status: -1, // 训练筛选
                condition: -1, // 条件筛选
            },

            enrollLabel: {
                已报名: "已报名",
                需报名: "需要报名",
                合作咨询: "合作咨询",
            },

            //训练分类
            sortList: [],

            // 训练筛选
            selectTask: [
                {
                    id: 0,
                    name: "已截止",
                },
                {
                    id: 1,
                    name: "已完成",
                },
                {
                    id: 2,
                    name: "未完成",
                },
            ],

            //条件筛选
            selectCondition: [
                {
                    id: 0,
                    name: "无需报名",
                },
                {
                    id: 1,
                    name: "需报名",
                },
                {
                    id: 3,
                    name: "合作咨询",
                },
            ],

            pageParams: {
                page: 1,
                page_size: 6,
                total: 0,
            },
        };
    },
    props: {
        company: {
            type: Object,
        },
    },

    created() {
        this.getTaskType();
        this.getCompanyTaskList();
    },

    computed: {
        filterParams() {
            const params = {};

            if (this.filter.type !== -1) params.task_type_id = this.filter.type;
            if (this.filter.status !== -1) params.task_state = this.filter.status;
            if (this.filter.condition !== -1) params.task_condition = this.filter.condition;

            return params;
        },
    },

    methods: {
        //训练分类
        getTaskType() {
            this.$httpStudent.axiosGet(
                this.$api.taskTypeList,
                (res) => {
                    this.sortList = res;
                },
                (err) => {
                    console.log(err);
                }
            );
        },

        chooseFilter(key, id) {
            const prev = this.filter[key];
            this.filter[key] = id;

            if (prev !== this.filter[key]) {
                this.pageParams.page = 1;
                this.getCompanyTaskList();
            }
        },

        handlePageChange(val) {
            this.pageParams.page = val;

            this.getCompanyTaskList();
        },

        // 获取企业训练列表
        getCompanyTaskList() {
            // this.$message.success("搜索企业训练列表");
            const params = {
                type: 2,
                page: this.pageParams.page,
                limit: this.pageParams.page_size,
                company_id: this.company.id,
                ...this.filterParams,
            };

            this.$httpStudent.axiosGetBy(this.$api.studentTaskList, params, (res) => {
                if (res.code === 200) {
                    this.pageParams.total = res.total || 0;
                    this.taskList = res.list || 0;
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        //查看训练详情
        goDetial(item) {
            let path = "";

            if (item.userData) {
                path = this.$router.resolve({
                    path: "/student/task/detail",
                    query: {
                        id: item.task_id,
                        user_id: item.userData[0].user_account_id,
                    },
                }).href;
            } else {
                path = this.$router.resolve({
                    path: "/student/task/detail",
                    query: {
                        id: item.task_id,
                    },
                }).href;
            }

            if (path) {
                localStorage.removeItem("defaultActive");
                window.open(path, "_blank");
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.task_box {
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
    margin-top: 20px;

    .header_box {
        padding: 20px 30px;
        box-sizing: border-box;
        border-bottom: 1px solid #e9e9e9;

        .condition_box {
            margin-bottom: 20px;
            // width: 784px;
            display: flex;
            align-items: first baseline;

            .label_box {
                width: 80px;
                height: 22px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #666666;
                flex-shrink: 0;
            }

            .value_box {
                display: flex;
                align-items: center;
                gap: 20px;
                flex-wrap: wrap;
                font-weight: 400;
                font-size: 14px;

                .select {
                    color: #685ef5;
                }

                div {
                    cursor: pointer;
                }
            }
        }
    }

    .detial_box {
        padding: 24px 30px;
        box-sizing: border-box;

        .all_task_show {
            margin-top: 20px;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 12px;

            .task_detial {
                min-width: 0;
                background: #ffffff;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #e6e6e6;
                box-sizing: border-box;
                overflow: hidden;

                .image {
                    width: 100%;
                    height: 204px;
                    position: relative;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                    .tip {
                        position: absolute;
                        top: 9px;
                        left: 14px;
                        padding: 2px 6px;
                        background: #ffd107;
                        border-radius: 2px 2px 2px 2px;
                        font-weight: 500;
                        font-size: 12px;
                        color: #161823;
                    }
                }
                .traing_detial {
                    width: 100%;
                    padding: 12px 16px;
                    box-sizing: border-box;
                    .title {
                        width: 100%;
                        font-weight: 500;
                        font-size: 16px;
                        color: #252632;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                    }
                    .images {
                        display: flex;
                        align-items: center;
                        margin-top: 20px;
                        gap: 8px;

                        img {
                            width: 24px;
                            height: 24px;
                            border-radius: 50%;
                        }
                    }
                    .tip {
                        font-weight: 400;
                        font-size: 12px;
                        color: #666666;
                        padding: 12px 0 16px 0;
                        background: #ffffff;
                        border-radius: 4px 4px 4px 4px;
                        border-bottom: 1px solid #e6e6e6;
                    }
                    .footer_box {
                        height: 54px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        font-weight: 400;
                        font-size: 12px;
                        color: #666666;

                        .el-button {
                            width: 80px;
                            height: 32px;
                            background: #ebeaff;
                            border-radius: 4px 4px 4px 4px;
                            font-weight: 400;
                            font-size: 14px;
                            color: #594fee;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: none;
                        }
                    }
                }
            }
        }

        .detail-empty {
            padding-block: 150px;
            color: #999999;
        }
    }

    .pagination {
        padding-bottom: 16px;
    }
}
</style>
